import React from 'react';

function About() {
    return (
        <main className="container my-5">
            <h1 className="mb-5 text-center text-primary fw-bold">About Our Family Business</h1>

            {/* Family Photo */}
            <section className="mb-5 text-center">
                <img
                    src="/assets/images/family-full.jpg"
                    alt="The Shiny Squad Cleaning family"
                    className="img-fluid rounded shadow-lg"
                    style={{ maxHeight: '400px', objectFit: 'cover', transition: 'transform 0.3s ease' }}
                    onMouseOver={e => (e.currentTarget.style.transform = 'scale(1.05)')}
                    onMouseOut={e => (e.currentTarget.style.transform = 'scale(1)')}
                />
            </section>

            {/* Story Section */}
            <section className="mb-5">
                <h2 className="text-secondary mb-3">Our Story</h2>
                <p className="fs-5 text-dark">
                    Shiny Squad Cleaning is a family-run business committed to providing dependable and high-quality cleaning services
                    for homes, offices, and rentals in Utah County.
                </p>
                <p className="fs-5 text-dark">
                    We take pride in treating every space like it’s our own — with care, respect, and attention to detail. We’re grateful
                    to be part of this community and look forward to helping your space shine.
                </p>
            </section>
        </main>
    );
}

export default About;
